import rush from './RushInfo.json';

const rushInfo = rush;

export const RushCalculator = {

    businessDays: (rushDate) => {

        let start = new Date(); // today's date
        let end = new Date(rushDate);
        let count = 0;

        while (start < end) {
            const day = start.getDay();
            if (day !== 0 && day !== 6) count++; // Skip Sunday (0) and Saturday (6)
            start.setDate(start.getDate() + 1);
        }

        return count;
    },

    calculate: (productSlug, rushDate) => {
        const businessDays = RushCalculator.businessDays(rushDate);

        const rushLevel = Object.values(rushInfo[productSlug]).find((rushLevel) =>
            rushLevel.businessDays.includes(businessDays)
        );
        const fee = rushLevel ? rushLevel.fee : "";

        return (
            <>
                A rush fee of <strong>{fee}</strong> will be applied to your order.
            </>
        );
    }
};
